export default "__VITE_ASSET__1f2e2742__"